import { combineReducers } from 'redux';
import adminReducer from '../admin/reducers';
import recruiterReducer from '../recruiter/reducers';
import artistReducer from '../artist/reducers';

/**
 * @author Sarthak Sharma
 * @since 02-01-2024
 * @description to combine all reducers
 * @type {Reducer<CombinedState<unknown>>}
 */

const rootReducer = combineReducers({
    ...adminReducer,
    ...recruiterReducer,
    ...artistReducer
})

export default rootReducer;